// Cookie Notice
document.addEventListener("DOMContentLoaded", function() {

    var cookieNotice = document.getElementById('cookie-notice');
    var okCookieButton = document.getElementById('ok-cookie');

    // Sets a cookie with the specified key
    function setCookie(key) {
        document.cookie = `${key.toLowerCase().replace(/\s+/g, '-')}-consent=true; expires=Thu, 18 Dec 2099 12:00:00 UTC; path=/`;
    }

    // Hides the cookie notice element
    function hideCookieNotice() {
        cookieNotice.classList.remove('show');
    }

    // Shows the cookie notice element
    function showCookieNotice() {
        cookieNotice.classList.add('show');
    }

    function removeAllCookieScripts() {
        var cookieScripts = document.querySelectorAll('[id$="-cookie-script"]');
        cookieScripts.forEach(function(script) {
            script.parentNode.removeChild(script);
        });
    }

    // Loads an optional cookie script based on the provided key
    function loadOptionalCookie(key) {
        var optionalCookieScript = document.createElement('script');
        optionalCookieScript.type = 'text/javascript';
        optionalCookieScript.id = key.toLowerCase().replace(/\s+/g, '-') + '-cookie-script';
        optionalCookieScript.textContent = scriptsData[key];
        document.head.appendChild(optionalCookieScript);
    }

    // Function to check if the cookie exists
    function checkCookie(name) {
        return document.cookie.split(';').some((item) => item.trim() === `${name}-consent=true`);
    }

    // Function to mark checkboxes based on existing cookies
    function markCheckboxes() {
        var allCheckboxes = document.querySelectorAll('input[type="checkbox"].script-cookie');
        allCheckboxes.forEach(function(checkbox) {
            var cookieName = checkbox.value;
            if (checkCookie(cookieName)) {
                checkbox.checked = true;
            }
        });
    }

    // Function to delete all cookies
    function deleteAllCookies() {
        removeAllCookieScripts();
        var cookies = document.cookie.split(";");
        for (var i = 0; i < cookies.length; i++) {
            var cookie = cookies[i];
            var eqPos = cookie.indexOf("=");
            var name = eqPos > -1 ? cookie.substr(0, eqPos) : cookie;
            document.cookie = name + "=;expires=Thu, 01 Jan 1970 00:00:00 GMT;path=/";
        }
    }

    // Check if the cookie exists
    var cookieConsentExists = document.cookie.indexOf('cookie-consent=true') > -1;
    if (!cookieConsentExists && cookieNotice) {
        showCookieNotice();
    }

    // Event listener for the "OK" cookie button
    if (okCookieButton) {
        okCookieButton.addEventListener('click', function(e) {
            deleteAllCookies();
            setCookie('cookie');
            hideCookieNotice();
        });
    }

    // Check if scriptsData is defined before ask for scriptsData
    if(typeof scriptsData !== 'undefined') {
        var acceptAllButton = document.getElementById('accept-all');
        var acceptSelectionButton = document.getElementById('accept-selection');
        var allCheckboxes = document.querySelectorAll('input[type="checkbox"].script-cookie');

        if (acceptAllButton) {
            acceptAllButton.addEventListener('click', function() {
                deleteAllCookies();
                setCookie('cookie');

            if (allCheckboxes.length > 0) {
                allCheckboxes.forEach(function(checkbox) {
                    checkbox.checked = true;
                    setCookie(checkbox.value);

                    Object.keys(scriptsData).forEach(function(key) {
                        if (key.toLowerCase() === checkbox.value.toLowerCase()) {
                            loadOptionalCookie(key);
                        }
                    }); 
                });
                setTimeout(function() {
                    hideCookieNotice();
                }, 800);
            } else {
                var keys = Object.keys(scriptsData);
                for (var key of keys) {
                    setCookie(key);
                    loadOptionalCookie(key);
                }
                hideCookieNotice(); 
            }
        })};
    
        if (acceptSelectionButton) {
            acceptSelectionButton.addEventListener('click', function() {
                var selectedCheckboxes = [];
                deleteAllCookies();
                setCookie('cookie');

                allCheckboxes.forEach(function(checkbox) {
                    if (checkbox.checked) {
                        selectedCheckboxes.push(checkbox.value);
                        setCookie(checkbox.value);

                        Object.keys(scriptsData).forEach(function(key) {
                            if (key.toLowerCase() === checkbox.value.toLowerCase()) {
                                loadOptionalCookie(key);
                            }
                        });
                    }
                });
                hideCookieNotice();
            });
        }
    }
    

    // Load optional cookie scripts if cookies have been previously accepted
    if(typeof scriptsData !== 'undefined') {
        var keys = Object.keys(scriptsData);
        keys.forEach(function(key) {
            if (document.cookie.indexOf(key.toLowerCase().replace(/\s+/g, '-') + '-consent=true') > -1) {
                loadOptionalCookie(key);
            }
        });
    }

    // Reset cookies link/button
    var resetCookies = document.getElementById('reset-cookies');
    if (resetCookies) {
        var closeCookieNoticeBtn = document.getElementById('cookie-notice_btn-close');
        resetCookies.addEventListener('click', function(e) {
            e.preventDefault();
            markCheckboxes();
            showCookieNotice();
            closeCookieNoticeBtn.classList.add('show');

            closeCookieNoticeBtn.addEventListener('click', function() {
                hideCookieNotice();
            });
        });
    }
});
